import { render, staticRenderFns } from "./NaoConformidadeInox.vue?vue&type=template&id=28081198&"
import script from "./NaoConformidadeInox.vue?vue&type=script&lang=js&"
export * from "./NaoConformidadeInox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports